var map = {
	"../../pages/resources/resources.module": [
		"./src/app/pages/resources/resources.module.ts",
		"pages-resources-resources-module"
	],
	"../boat-log/boat-log.module": [
		"./src/app/pages/boat-log/boat-log.module.ts",
		"boat-log-boat-log-module"
	],
	"../boat-management/boat-management.module": [
		"./src/app/pages/boat-management/boat-management.module.ts",
		"common",
		"boat-management-boat-management-module"
	],
	"../boat-map/boat-map.module": [
		"./src/app/pages/boat-map/boat-map.module.ts",
		"default~boat-map-boat-map-module~pages-add-new-project-add-new-project-module~pages-application-log-~a7444aa6",
		"default~boat-map-boat-map-module~pages-all-sections-all-sections-module~pages-boat-boat-module~pages~be4d554e",
		"default~boat-map-boat-map-module~pages-task-task-module",
		"common",
		"boat-map-boat-map-module"
	],
	"../boat-plan/boat-plan.module": [
		"./src/app/pages/boat-plan/boat-plan.module.ts",
		"default~boat-plan-boat-plan-module~pages-add-new-project-add-new-project-module",
		"common",
		"boat-plan-boat-plan-module"
	],
	"../boat-report/boat-report.module": [
		"./src/app/pages/boat-report/boat-report.module.ts",
		"common",
		"boat-report-boat-report-module"
	],
	"../resources/resources.module": [
		"./src/app/statics/resources/resources.module.ts",
		"common",
		"resources-resources-module"
	],
	"../shipyard/shipyard.module": [
		"./src/app/statics/shipyard/shipyard.module.ts",
		"shipyard-shipyard-module"
	],
	"../shipyards/shipyards.module": [
		"./src/app/pages/shipyards/shipyards.module.ts",
		"shipyards-shipyards-module"
	],
	"./pages/add-draft-draw/add-draft-draw.module": [
		"./src/app/pages/add-draft-draw/add-draft-draw.module.ts",
		"common",
		"pages-add-draft-draw-add-draft-draw-module"
	],
	"./pages/add-draft-info/add-draft-info.module": [
		"./src/app/pages/add-draft-info/add-draft-info.module.ts",
		"common",
		"pages-add-draft-info-add-draft-info-module"
	],
	"./pages/add-draft-map/add-draft-map.module": [
		"./src/app/pages/add-draft-map/add-draft-map.module.ts",
		"common",
		"pages-add-draft-map-add-draft-map-module"
	],
	"./pages/add-draft-photo/add-draft-photo.module": [
		"./src/app/pages/add-draft-photo/add-draft-photo.module.ts",
		"pages-add-draft-photo-add-draft-photo-module"
	],
	"./pages/add-new-project/add-new-project.module": [
		"./src/app/pages/add-new-project/add-new-project.module.ts",
		"default~boat-map-boat-map-module~pages-add-new-project-add-new-project-module~pages-application-log-~a7444aa6",
		"default~boat-plan-boat-plan-module~pages-add-new-project-add-new-project-module",
		"common",
		"pages-add-new-project-add-new-project-module"
	],
	"./pages/add-new-yacht/add-new-yacht.module": [
		"./src/app/pages/add-new-yacht/add-new-yacht.module.ts",
		"default~pages-add-new-yacht-add-new-yacht-module~pages-edit-yacht-edit-yacht-module",
		"common",
		"pages-add-new-yacht-add-new-yacht-module"
	],
	"./pages/add-yacht-history/add-yacht-history.module": [
		"./src/app/pages/add-yacht-history/add-yacht-history.module.ts",
		"pages-add-yacht-history-add-yacht-history-module"
	],
	"./pages/all-sections/all-sections.module": [
		"./src/app/pages/all-sections/all-sections.module.ts",
		"default~boat-map-boat-map-module~pages-all-sections-all-sections-module~pages-boat-boat-module~pages~be4d554e",
		"common",
		"pages-all-sections-all-sections-module"
	],
	"./pages/application-log/application-log.module": [
		"./src/app/pages/application-log/application-log.module.ts",
		"default~boat-map-boat-map-module~pages-add-new-project-add-new-project-module~pages-application-log-~a7444aa6",
		"common",
		"pages-application-log-application-log-module"
	],
	"./pages/boat/boat.module": [
		"./src/app/pages/boat/boat.module.ts",
		"default~boat-map-boat-map-module~pages-all-sections-all-sections-module~pages-boat-boat-module~pages~be4d554e",
		"common",
		"pages-boat-boat-module"
	],
	"./pages/edit-yacht/edit-yacht.module": [
		"./src/app/pages/edit-yacht/edit-yacht.module.ts",
		"default~pages-add-new-yacht-add-new-yacht-module~pages-edit-yacht-edit-yacht-module",
		"common",
		"pages-edit-yacht-edit-yacht-module"
	],
	"./pages/environmental-log/environmental-log.module": [
		"./src/app/pages/environmental-log/environmental-log.module.ts",
		"default~boat-map-boat-map-module~pages-add-new-project-add-new-project-module~pages-application-log-~a7444aa6",
		"common",
		"pages-environmental-log-environmental-log-module"
	],
	"./pages/export-application/export-application.module": [
		"./src/app/pages/export-application/export-application.module.ts",
		"default~boat-map-boat-map-module~pages-add-new-project-add-new-project-module~pages-application-log-~a7444aa6",
		"common",
		"pages-export-application-export-application-module"
	],
	"./pages/export-available-surface/export-available-surface.module": [
		"./src/app/pages/export-available-surface/export-available-surface.module.ts",
		"common",
		"pages-export-available-surface-export-available-surface-module"
	],
	"./pages/export-environmentals/export-environmentals.module": [
		"./src/app/pages/export-environmentals/export-environmentals.module.ts",
		"default~boat-map-boat-map-module~pages-add-new-project-add-new-project-module~pages-application-log-~a7444aa6",
		"common",
		"pages-export-environmentals-export-environmentals-module"
	],
	"./pages/export-list-of-points/export-list-of-points.module": [
		"./src/app/pages/export-list-of-points/export-list-of-points.module.ts",
		"default~boat-map-boat-map-module~pages-add-new-project-add-new-project-module~pages-application-log-~a7444aa6",
		"common",
		"pages-export-list-of-points-export-list-of-points-module"
	],
	"./pages/home/home.module": [
		"./src/app/pages/home/home.module.ts",
		"pages-home-home-module"
	],
	"./pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"pages-login-login-module"
	],
	"./pages/project-budget/project-budget.module": [
		"./src/app/pages/project-budget/project-budget.module.ts",
		"pages-project-budget-project-budget-module"
	],
	"./pages/project-drive-folder/project-drive-folder.module": [
		"./src/app/pages/project-drive-folder/project-drive-folder.module.ts",
		"pages-project-drive-folder-project-drive-folder-module"
	],
	"./pages/project-products/project-products.module": [
		"./src/app/pages/project-products/project-products.module.ts",
		"common",
		"pages-project-products-project-products-module"
	],
	"./pages/project-sections/project-sections.module": [
		"./src/app/pages/project-sections/project-sections.module.ts",
		"pages-project-sections-project-sections-module"
	],
	"./pages/project-users/project-users.module": [
		"./src/app/pages/project-users/project-users.module.ts",
		"common",
		"pages-project-users-project-users-module"
	],
	"./pages/project-zones/project-zones.module": [
		"./src/app/pages/project-zones/project-zones.module.ts",
		"common",
		"pages-project-zones-project-zones-module"
	],
	"./pages/remark-log/remark-log.module": [
		"./src/app/pages/remark-log/remark-log.module.ts",
		"pages-remark-log-remark-log-module"
	],
	"./pages/reset-password/reset-password.module": [
		"./src/app/pages/reset-password/reset-password.module.ts",
		"pages-reset-password-reset-password-module"
	],
	"./pages/settings/settings.module": [
		"./src/app/pages/settings/settings.module.ts",
		"pages-settings-settings-module"
	],
	"./pages/shipyard-edit/shipyard-edit.module": [
		"./src/app/pages/shipyard-edit/shipyard-edit.module.ts",
		"pages-shipyard-edit-shipyard-edit-module"
	],
	"./pages/shipyard/shipyard.module": [
		"./src/app/pages/shipyard/shipyard.module.ts",
		"pages-shipyard-shipyard-module"
	],
	"./pages/surface-availability/surface-availability.module": [
		"./src/app/pages/surface-availability/surface-availability.module.ts",
		"pages-surface-availability-surface-availability-module"
	],
	"./pages/task/task.module": [
		"./src/app/pages/task/task.module.ts",
		"default~boat-map-boat-map-module~pages-all-sections-all-sections-module~pages-boat-boat-module~pages~be4d554e",
		"default~boat-map-boat-map-module~pages-task-task-module",
		"common",
		"pages-task-task-module"
	],
	"./statics/home/home.module": [
		"./src/app/statics/home/home.module.ts",
		"statics-home-home-module"
	],
	"./statics/icons/icons.module": [
		"./src/app/statics/icons/icons.module.ts",
		"statics-icons-icons-module"
	],
	"./statics/management/management.module": [
		"./src/app/statics/management/management.module.ts",
		"common",
		"statics-management-management-module"
	],
	"./statics/project-set-budget/project-set-budget.module": [
		"./src/app/statics/project-set-budget/project-set-budget.module.ts",
		"statics-project-set-budget-project-set-budget-module"
	],
	"./statics/resources/resources.module": [
		"./src/app/statics/resources/resources.module.ts",
		"common",
		"resources-resources-module"
	],
	"./statics/shipyard/shipyard.module": [
		"./src/app/statics/shipyard/shipyard.module.ts",
		"shipyard-shipyard-module"
	],
	"./statics/surface-available/surface-available.module": [
		"./src/app/statics/surface-available/surface-available.module.ts",
		"statics-surface-available-surface-available-module"
	],
	"./statics/surface-report/surface-report.module": [
		"./src/app/statics/surface-report/surface-report.module.ts",
		"statics-surface-report-surface-report-module"
	],
	"./statics/theme/theme.module": [
		"./src/app/statics/theme/theme.module.ts",
		"common",
		"statics-theme-theme-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;